// extracted by mini-css-extract-plugin
export var logo = "SiteHeader-module--logo--0d97a";
export var nav = "SiteHeader-module--nav--7f018";
export var navbarAlt = "SiteHeader-module--navbarAlt--5f643";
export var partnershipLogo = "SiteHeader-module--partnershipLogo--f92ee";
export var partnershipLogos = "SiteHeader-module--partnershipLogos--c4d51";